import React from 'react';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="w-full py-20 md:py-28 px-6 bg-beige scroll-mt-10" data-id="element-127">
      <div className="max-w-5xl mx-auto" data-id="element-128">
        <div className="text-center mb-16" data-id="element-129">
          <h2 className="font-playfair text-4xl md:text-5xl text-dark mb-4" data-id="element-130">
            Elige tu camino de sanación
          </h2>
          <p className="text-dark/70 font-light text-lg" data-id="element-131">
            Selecciona el plan que mejor se adapte a tu momento actual.
          </p>
          <p className="text-terracotta font-medium text-sm mt-3 tracking-wide" data-id="element-132">
            Empiezas hoy. Acceso inmediato.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-133">
          {/* PLAN ESENCIAL */}
          <div className="bg-white p-10 rounded-2xl border border-dark/10 shadow-sm flex flex-col h-full" data-id="element-134">
            <div className="mb-8 text-center" data-id="element-135">
              <h3 className="font-playfair text-2xl text-dark font-medium mb-2" data-id="element-136">
                PLAN ESENCIAL
              </h3>
              <div className="text-4xl font-bold text-dark mb-4" data-id="element-137">
                $19.990{' '}
                <span className="text-lg font-normal text-dark/50" data-id="element-138">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-10 flex-1 text-dark/80 font-light" data-id="element-139">
              <li className="flex items-start gap-3" data-id="element-140">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" data-id="element-141" />
                <span data-id="element-142">Sistema base</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-143">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" data-id="element-144" />
                <span data-id="element-145">Ejercicios prácticos</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-146">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" data-id="element-147" />
                <span data-id="element-148">Cartas terapéuticas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-149">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" data-id="element-150" />
                <span data-id="element-151">Diario básico</span>
              </li>
            </ul>

            <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWNAKj3woEtaILgDgXFPg65J/es-ar?_r=AQAB0DHymYAk4H97UmHxz2WIjlfu54BZJyqR2iirSNEAqXw&preview_theme_id=186487341342" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 bg-dark text-white text-center font-medium rounded-full hover:bg-dark/90 transition-colors duration-300" data-id="element-152">
              Comenzar Plan Esencial
            </a>
          </div>

          {/* PLAN PRO */}
          <div className="bg-white p-10 rounded-2xl border-2 border-terracotta shadow-2xl shadow-terracotta/10 flex flex-col h-full relative transform md:-translate-y-4" data-id="element-153">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-terracotta text-white px-6 py-1.5 rounded-full text-sm font-semibold tracking-wide shadow-md" data-id="element-154">
              MÁS ELEGIDO
            </div>

            <div className="mb-8 text-center mt-4" data-id="element-155">
              <h3 className="font-playfair text-2xl text-terracotta font-bold mb-2" data-id="element-156">
                PLAN PRO
              </h3>
              <p className="text-dark/60 font-light text-sm mb-3 italic" data-id="element-157">
                Para quienes ya entendieron que esto no es casualidad.
              </p>
              <div className="text-4xl font-bold text-dark mb-4" data-id="element-158">
                $25.990{' '}
                <span className="text-lg font-normal text-dark/50" data-id="element-159">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-10 flex-1 text-dark font-medium" data-id="element-160">
              <li className="flex items-start gap-3" data-id="element-161">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={3} data-id="element-162" />
                <span data-id="element-163">Todo el Plan Esencial</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-164">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={3} data-id="element-165" />
                <span data-id="element-166">Sistema completo</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-167">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={3} data-id="element-168" />
                <span data-id="element-169">Ejercicios avanzados</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-170">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={3} data-id="element-171" />
                <span data-id="element-172">Plantillas de trabajo</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-173">
                <CheckIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={3} data-id="element-174" />
                <span data-id="element-175">Diario guiado profundo</span>
              </li>
            </ul>

            <p className="text-center text-dark/50 font-light text-xs mb-6 italic" data-id="element-176">
              Más profundidad. Más claridad. Más transformación.
            </p>

            <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWNAKj8NIHOJaW6mcYseR06c/es-ar?_r=AQABl0Exuj1yJLqddKsIp6DiStfMIyPV5G1B8OvrMWhpBPc" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 bg-terracotta text-white text-center font-bold rounded-full hover:bg-terracotta-hover transition-colors duration-300 shadow-lg shadow-terracotta/30" data-id="element-177">
              Comenzar Plan Pro
            </a>
          </div>
        </div>
      </div>
    </section>;
}